import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import EditProfile from "./editProfile";
import General from "./general";
import MailboxAccessRequest from "./mailboxAccessRequest";
import RequestMailboxAccess from "./requestMailboxAccessRequest";
import "./styles.scss";
function UserProfile() {
    const SiteInfo = useSelector((state: RootState) => state.SiteInformation);
    const [componentToShow, setComponentToShow] = useState<string>(SiteInfo.userProfileInitialTab ?? "general");

    return (
        <div className="alternateView">
            <div className="col1">
                <div className="header">User Profile</div>
                <div
                    className={
                        componentToShow == "general" || componentToShow == "editProfile"
                            ? "selectedPreference"
                            : "preference"
                    }
                    onClick={() => {
                        setComponentToShow("general");
                    }}
                >
                    Details
                </div>
                <div
                    className={componentToShow == "mailboxAccessRequests" ? "selectedPreference" : "preference"}
                    onClick={() => {
                        setComponentToShow("mailboxAccessRequests");
                    }}
                >
                    Mailbox Access Requests
                </div>
            </div>
            <div className="col2">
                {componentToShow == "general" && (
                    <General
                        onEditProfile={() => setComponentToShow("editProfile")}
                        onRequestMailboxAccess={() => setComponentToShow("mailboxAccessRequests")}
                    ></General>
                )}
                {componentToShow == "editProfile" && <EditProfile></EditProfile>}
                {componentToShow == "mailboxAccess" && <RequestMailboxAccess></RequestMailboxAccess>}
                {componentToShow == "mailboxAccessRequests" && <MailboxAccessRequest></MailboxAccessRequest>}
            </div>
        </div>
    );
}
export default UserProfile;
